module.exports = __webpack_public_path__ + "img/a262a15.jpg";